// TODO: Need Audit Rename Files MobileScheduleTabs
import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import MobileScheduleTabs from 'mobile/components/livestreaming_schedule_tabs';
import ScheduleTabs from 'shared/components/schedule_tabs';
import { isMobile, ActiveLanguage } from 'shared/vidio_helpers';
import WindowAdapter from 'shared/window_adapter';
import $ from 'jquery';
const Cookies = require('js-cookie');

export default class ScheduleRetriever {
  constructor({ $element: $element}){
    this.$element = $element;
    this.scheduleTabs = null;
  }

  init() {
    this.request();
  }

  getLivestreamingId() {
    return this.$element.data('livestreaming-id');
  }

  getCatchupId() {
    return this.$element.data('catchup-id');
  }

  getCatchupDate() {
    return this.$element.data('catchup-date');
  }

  getCatchupTab(){
    var el = document.querySelector('a.b-livestreaming-daily-schedule__list-date-item[data-tab-for="#schedule-content-'+this.getCatchupDate()+'"]');
    return el;
  }

  getVideoId() {
    return this.$element.data('video-id')
  }

  buildRequestURL() {
    let localestring = Cookies.get('locale') || ''
    let baseUrl = `/live/${this.getLivestreamingId()}/schedules`
    let videoId = this.getVideoId()

    if (localestring != ''){
      baseUrl = `${baseUrl}?locale=${localestring}`
    }
    else {
      baseUrl = `${baseUrl}?locale=id`;
    }

    if (videoId) {
      baseUrl = `${baseUrl}&video_id=${videoId}`
    }

    return baseUrl
  }

  request(onRequestDone){
    let requestURL = this.buildRequestURL()

    const options = {
      method: "GET",
      url: requestURL
    };

    $.ajax(options).done((data) => {
      this.render(data);
      if(this.hasSchedules()) {
        this.initScheduleTabs();
        this.setActiveSchedule();
        this.scrollToActive();
      }
      if (onRequestDone !== undefined) {
        onRequestDone();
      }
    });
  }

  showMobileDatePicker() {
    let dateContainer = this.$element[0].querySelector('.b-livestreaming-daily-schedule__date-container');
    let dateLabel = dateContainer.querySelector('.b-livestreaming-daily-schedule__date')
    if (dateContainer){
      dateContainer.classList.remove('hide-me');
    }

    if (dateLabel) {
      dateLabel.classList.add('hide')
    }
  }

  showDesktopDatePicker() {
    let dateContainer = this.$element[0].querySelector('.b-livestreaming-daily-schedule__date-container');
    if (dateContainer){
      dateContainer.classList.remove('hide-me');
    }
  }

  initScheduleTabs(){
    var currentTab = null;
    if(this.scheduleTabs != null) {
      currentTab = this.scheduleTabs.currentTab;
    }

    if (isMobile()) {
      this.showMobileDatePicker();
      let tabElement = this.$element[0].querySelector("#schedule-tab");
      this.scheduleTabs = this.createScheduleTabs(tabElement);
    } else {
      this.showDesktopDatePicker();
      let tabElement = this.$element[0].querySelector("#schedule-tab");
      this.scheduleTabs = this.createScheduleTabs(tabElement);
    }
    this.scheduleTabs.init();

    if(currentTab != null) {
      this.scheduleTabs.currentTab = currentTab;
      this.scheduleTabs.toggleActive(this.scheduleTabs.currentTab);
    }

    if(currentTab == null && this.getCatchupId() != null) {
      this.scheduleTabs.currentTab = this.getCatchupTab();
      this.scheduleTabs.toggleActive(this.scheduleTabs.currentTab);
    }
  }

  isLivestreamingPage() {
    return /^\/live\//.test(WindowAdapter.locationPathname());
  }

  replaceLivestreamingHref() {
    var el = this.$element[0].querySelector("#playing-schedule");
    if (el != null) el.href = "#";
  }

  setActiveSchedule() {
    this.scrollDatePickerToActive()
    var el;
    var catchupId = this.getCatchupId();
    if (catchupId != null) {
      el = this.$element[0].querySelector("#schedule-item-" + this.getCatchupId());
    }
    else {
      el = this.$element[0].querySelector("#playing-schedule .b-livestreaming-daily-schedule__item");
    }

    if (el != null) {
      el.classList.add("active");
    }
  }

  scrollToActive() {
    var activePane = document.getElementsByClassName('b-livestreaming-daily-schedule__content tab-active')[0];
    if(activePane){
      var scroll = activePane.getElementsByClassName('b-livestreaming-daily-schedule__scroll-container')[0];
      if(scroll){
        var active = scroll.getElementsByClassName('active')[0];
        if(active){
          this._setScrollTop(scroll, active.offsetTop-200);
        }
      }
    }
  }

  scrollDatePickerToActive() {
    if (!isMobile()) { return }
    let activeSchedule = document.querySelector('.b-livestreaming-daily-schedule__content.tab-active');

    if (activeSchedule == undefined) { return }
    let key = activeSchedule.id
    let datePickerContainer = document.querySelector('.b-livestreaming-daily-schedule__date-container')

    if (datePickerContainer == undefined) { return }
    this.updateDatePickerText(datePickerContainer)

    let datePickerElement = document.querySelector(`[data-tab-for="#${key}"]`)

    if (datePickerElement == undefined) { return }
    datePickerElement.classList.add('tab-active')

    let elementPosition = (datePickerElement.offsetLeft - 15) - ((datePickerContainer.offsetWidth / 2) - (datePickerElement.offsetWidth / 2))
    datePickerContainer.scrollLeft += elementPosition
  }

  updateDatePickerText(datePickerContainer) {
    let lang = ActiveLanguage.get();
    let now = new Date()
    let today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    let tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    let datePickerElements = datePickerContainer.querySelectorAll('.b-livestreaming-daily-schedule__list-date-item')

    if (datePickerElements == undefined) { return }
    datePickerElements.forEach((element) => {
      let scheduleDate = element.dataset.scheduleDate
      let scheduleMonth = element.dataset.scheduleMonth - 1
      let scheduleYear = element.dataset.scheduleYear
      let currentScheduleDate = new Date(scheduleYear, scheduleMonth, scheduleDate)

      if (currentScheduleDate.getTime() == today.getTime()) {
        element.innerText = window.Locale[lang].time.today
      }

      if (currentScheduleDate.getTime() == tomorrow.getTime()) {
        element.innerText = window.Locale[lang].time.tomorrow
      }
    })
  }

  _setScrollTop(element, offset) {
    if(element){
      element.scrollTop = offset;
    }
  }

  render(htmlResponse){
    this.$element.removeClass('livestreaming-empty-state');
    this.$element.empty();
    this.$element.append(htmlResponse);
    if (this.isLivestreamingPage()) this.replaceLivestreamingHref();

    this.rebindingComponent();
  }

  rebindingComponent(){
    new ComponentInitializers();
  }

  createScheduleTabs(tabElement){
    return new ScheduleTabs(tabElement, this);
  }

  createMobileScheduleTabs(tabElement){
    return new MobileScheduleTabs(tabElement, this);
  }

  hasSchedules() {
    let elementFirstChild = this.$element[0].firstElementChild;
    return elementFirstChild !== null && !elementFirstChild.classList.contains("livestreaming-empty-state");
  }
}
